import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { COLORS, BUTTON_TYPE } from '@helpers/constants'
import Button from '@components/Button'

const Tabs = (props) => {
  const { children, startOnTab } = props
  const [activeTab, setActiveTab] = useState(
    startOnTab ? startOnTab : children[0].props.label
  )

  return (
    <>
      <ul className={'flex pb-4'}>
        {children.map((child) => {
          const { label } = child.props
          const isActive = label === activeTab
          return (
            <li key={label} className={'mr-2'}>
              <Button
                handleClick={() => {
                  setActiveTab(label)
                }}
                type={
                  isActive ? BUTTON_TYPE.PRIMARY : BUTTON_TYPE.PRIMARY_OUTLINE
                }
                textColor={
                  isActive ? COLORS.WHITE.TEXT : COLORS.PRIMARY_GREEN.TEXT
                }
                backgroundColor={
                  isActive
                    ? COLORS.PRIMARY_GREEN.BACKGROUND
                    : COLORS.PRIMARY_GREEN.BORDER
                }
              >
                {label}
              </Button>
            </li>
          )
        })}
      </ul>

      <div>
        {children.map((child) => {
          if (child.props.label !== activeTab) return null
          return child.props.children
        })}
      </div>
    </>
  )
}

const Tab = (props) => {
  const { children, label } = props
  return children
}

Tabs.propTypes = {
  children: PropTypes.any,
}

Tab.propTypes = {
  children: PropTypes.any,
  label: PropTypes.string.isRequired,
}

export { Tabs, Tab }
